/**
 * VendorsPageCockpit — Cockpit-language frame for /vendors.
 *
 * Wraps VendorsPage with a Cockpit Masthead + KPI strip; the interactive
 * vendors + PO admin content is preserved verbatim.
 */
import { useMemo } from "react";
import {
  CockpitPage, CockpitMasthead, HeroMetric, HeroDivider, CockpitKpiStrip,
} from "@/components/cockpit/CockpitShell";
import { useVendorPO } from "@/data/VendorPOContext";
import VendorsPage from "./VendorsPage";

export default function VendorsPageCockpit() {
  const { vendors, purchaseOrders } = useVendorPO();

  const stats = useMemo(() => {
    const total = vendors.length;
    const active = vendors.filter((v) => v.active).length;
    const pos = purchaseOrders.length;
    const openPOs = purchaseOrders.filter((p) => p.status !== "Delivered").length;
    return { total, active, pos, openPOs };
  }, [vendors, purchaseOrders]);

  return (
    <CockpitPage>
      <CockpitMasthead
        // eyebrow="Catalog · Vendors"
        title="Vendors & Purchase Orders"
        right={(
          <>
            <HeroMetric label="Active vendors" value={stats.active} hero />
            <HeroDivider />
            <HeroMetric label="Total vendors" value={stats.total} />
            <HeroMetric label="Open POs" value={stats.openPOs} tone={stats.openPOs > 0 ? "warn" : "default"} />
          </>
        )}
      />
      <CockpitKpiStrip
        items={[
          { label: "Total vendors", value: stats.total },
          { label: "Active", value: stats.active, tone: "good" },
          { label: "Total POs", value: stats.pos },
          { label: "Open POs", value: stats.openPOs, tone: stats.openPOs > 0 ? "warn" : "default" },
        ]}
      />
      <div className="cockpit-surface -mx-6">
        <div className="px-6">
          <VendorsPage />
        </div>
      </div>
    </CockpitPage>
  );
}
